//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';

export default {

  props: {
    file: { type: [Object, Array], default: () => ({}) },
    isErrorAvailable: { type: Boolean, default: true },
  },

  data() {
    return {
      source: '',
    };
  },

  computed: {
    getFileName() {
      return this.$props.file.name ?? this.$props.file[0].name;
    },

    getFileExtension() {
      return this.$props.file.extension ?? this.$props.file[0].extension;
    },
  },

  async mounted() {
    await this.imagePath(this.$props.file);
  },

  methods: {
    ...mapActions('p2pDeals', [
      'getFile',
    ]),

    imageError() {
      this.$emit('error');
    },

    async imagePath(file) {
      const res = await this.getFile(file.id ?? file[0].id);
      this.source = res;
    },
  },
};

